import { isCurrentBreakpoint, getBreakpointByName } from '@slickdeals/durango/dist/javascript/utilities/breakpoints';
/** The name of the module */
export const name = 'Breakpoints';
export var Breakpoints;
(function (Breakpoints) {
    Breakpoints["Desktop"] = "desktop";
    Breakpoints["Tablet"] = "tablet";
    Breakpoints["Mobile"] = "mobile";
})(Breakpoints || (Breakpoints = {}));
export const getDesktopBreakpoint = () => getBreakpointByName(Breakpoints.Desktop);
export const getTabletBreakpoint = () => getBreakpointByName(Breakpoints.Tablet);
export const getMobileBreakpoint = () => getBreakpointByName(Breakpoints.Mobile);
export const isDesktopBreakpoint = () => isCurrentBreakpoint(getDesktopBreakpoint());
export const isTabletBreakpoint = () => isCurrentBreakpoint(getTabletBreakpoint());
export const isMobileBreakpoint = () => isCurrentBreakpoint(getMobileBreakpoint());
